<div class="welcome-header" id="welcome-heading">
    <div class="welcome-message">
        <div class="welcome-text" id="welcome_headline">
            <span>{{props.headlineTitle}}</span>
        </div>
        <div class="welcome-description" id="welcome_description">
            <p><span class="savings-text">{{props.savingsText}}</span><a href="{{props.learnMoreURL}}" [attr.aria-label]="props.learnMore + ' about ' + props.savingsText">{{props.learnMore}}</a> {{props.headlineSubText}}</p>
        </div>
    </div>
</div>